<template>
<div id="container">
    <div class="container_wrap">
        <keep-alive>
            <!-- <dot-com-snb></dot-com-snb> -->
            <admin-snb></admin-snb>
        </keep-alive>
        <div id="contents">
            <div class="contents_wrap">
                <!-- logout -->
                <div class="landing_item">
                    <skp-breadcrumbs @page-title="val => pageTitle = val" />
                    <!-- //breadcrumbs -->
                    <h2 class="pg_title">{{ pageTitle }}</h2>
                    <!-- //contents_head -->
                    <p>
                        <em>Only the previous version of SKP is available. </em>
                        </br></br>
                        <em class="txt_color1" style="font-weight:700">
                            Warning : If you are not an authorized administrator of samsung.com, leave this menu immediately.
                        </em>
                        <em class="txt_color1" style="font-weight:700">
                            Caution : This menu is in service to public users. Any kind of operation on this menu will be published on samsung.com
                        </em>
                        </br></br>
                        <a href="javascript:" class="btn_blue" @click="btnPopupOpen">Click</a>
                    </p>
                </div>
            </div>
        </div>
    </div>
</div>
</template>
<script>
import Vue                  from 'vue';
import { mapGetters }       from 'vuex';
import qs                   from 'query-string';
import axios                from 'axios';
import store                from '@/vuex/store';
import { SDLUtil }          from '@/utils';
import DotComSnb            from './DotComSnb';
import AdminSnb             from '~va/main/AdminSnb';

import SKPBreadcrumbs       from '~vb/main/SKPBreadcrumbs';

const fetchDotCom = dotComMenuNm => axios.post(
    `${SDLUtil.API_URL}/basis/main/dotComSupportMenuLink.skp`,
    qs.stringify({ dotComMenuNm: dotComMenuNm }),
    { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
);

export default {
    name: 'DotComMain',
    props: {
        dotComMenuNm : { required: true }
    },
    data() {
        return {
            pageTitle: '',
            goUrl: '',
            queryParams: ''
        }
    },
    computed: {
        ...mapGetters({
            userCorpCd: 'getCorpCd',
        }),
    },
    components : {
        'skp-breadcrumbs'   : SKPBreadcrumbs,
        'dot-com-snb'       : DotComSnb,
        'admin-snb': AdminSnb,

    },
    methods: {
        async initLoad() {
            return await fetchDotCom(this.dotComMenuNm).then(resp => {
                    return resp.data;
                })
                .catch(err => {
                    SDLUtil.errorAlert(err);
                });
        },
        creDotComMenuUrl() {
            Vue.$log.info('▶ DotcomMain.vue ' + (SDLUtil.IS_DEV_MODE ? 'DEV' : 'ENV') + ' menu param =>', this.dotComMenuNm, ' / ', SDLUtil.DOTCOM_URL);
            let goURL = "";
            const dotComUrl = SDLUtil.DOTCOM_URL;
            if ("IA_Management" == this.dotComMenuNm)
                goURL = dotComUrl + "/general/IA_Management.jsp";
            else if ("modelManagement" == this.dotComMenuNm)
                goURL = dotComUrl + "/general/modelManagement.jsp";
            else if ("symptomManagement" == this.dotComMenuNm)
                goURL = dotComUrl + "/general/symptomManagement.jsp";
            else if ("surveyManagement" == this.dotComMenuNm)
                goURL = dotComUrl + "/admin/survey/surveyManagement.jsp";
            else if ("siteManagement" == this.dotComMenuNm)
                goURL = dotComUrl + "/admin/site/siteManagement.jsp";
            else if ("FAQ_List" == this.dotComMenuNm)
                goURL = dotComUrl + "/admin/Faq/FAQ_List.jsp";
            else if ("Faq_QA_List" == this.dotComMenuNm)
                goURL = dotComUrl + "/admin/QA/Faq_QA_List.jsp";
            else if ("Htg_List" == this.dotComMenuNm)
                goURL = dotComUrl + "/admin/HowToGuide/Htg_List.jsp";
            else if ("Htg_QA_List" == this.dotComMenuNm)
                goURL = dotComUrl + "/admin/QA/Htg_QA_List.jsp";
            else if ("Htv_List" == this.dotComMenuNm)
                goURL = dotComUrl + "/admin/HowToGuide/Htv_List.jsp";
            else if ("Htv_QA_List" == this.dotComMenuNm)
                goURL = dotComUrl + "/admin/QA/Htv_QA_List.jsp";
            else if ("Tsg_List" == this.dotComMenuNm)
                goURL = dotComUrl + "/admin/TroubleShootingGuide/Tsg_List.jsp";
            else if ("Tsg_QA_List" == this.dotComMenuNm)
                goURL = dotComUrl + "/admin/QA/Tsg_QA_List.jsp";
            else if ("Registration" == this.dotComMenuNm)
                goURL = dotComUrl + "/admin/report/Registration.jsp";
            else if ("Registration_Ca" == this.dotComMenuNm)
                goURL = dotComUrl + "/admin/report/Registration_Ca.jsp";
            else if ("ReportbySiteN" == this.dotComMenuNm)
                goURL = dotComUrl + "/statistics/ReportbySite.jsp";
            else if ("ReportbySiteY" == this.dotComMenuNm)
                goURL = dotComUrl + "/statistics/ReportbySite.jsp";
            else if ("ReportbyRegister_P" == this.dotComMenuNm)
                goURL = dotComUrl + "/statistics/ReportbyRegister.jsp";
            else if ("ReportbyRegister_R" == this.dotComMenuNm)
                goURL = dotComUrl + "/statistics/ReportbyRegister.jsp";
            else if ("ReportbyRegister_A" == this.dotComMenuNm)
                goURL = dotComUrl + "/statistics/ReportbyRegister.jsp";
            else if ("ReportbyRegisterContent" == this.dotComMenuNm)
                goURL = dotComUrl + "/statistics/ReportbyRegisterContent.jsp";
            else if ("ReportbyLocalizationRate" == this.dotComMenuNm)
                goURL = dotComUrl + "/statistics/ReportbyLocalizationRate.jsp";
            else if ("ResReportbySiteN" == this.dotComMenuNm)
                goURL = dotComUrl + "/resolution/ResReportbySite.jsp";
            else if ("ResReportbySiteY" == this.dotComMenuNm)
                goURL = dotComUrl + "/resolution/ResReportbySite.jsp";
            else if ("ResReportbyRegister_P" == this.dotComMenuNm)
                goURL = dotComUrl + "/resolution/ResReportbyRegister.jsp";
            else if ("ResReportbyRegister_R" == this.dotComMenuNm)
                goURL = dotComUrl + "/resolution/ResReportbyRegister.jsp";
            else if ("ResReportbyRegister_A" == this.dotComMenuNm)
                goURL = dotComUrl + "/resolution/ResReportbyRegister.jsp";
            else if ("ResReportbyRegisterContent" == this.dotComMenuNm)
                goURL = dotComUrl + "/resolution/ResReportbyRegisterContent.jsp";
            else if ("RiskContents" == this.dotComMenuNm)
                goURL = dotComUrl + "/analysis/riskAnalysis.jsp";
            else if ("InvalidContents" == this.dotComMenuNm)
                goURL = dotComUrl + "/analysis/invalidAnalysis.jsp";
            else if ("CaresApp" == this.dotComMenuNm)
                goURL = dotComUrl + "/caresApp/CaresReportbySite.jsp";
            else if ("STD_FAQ_List" == this.dotComMenuNm)
                goURL = dotComUrl + "/admin/Faq/STD_FAQ_List.jsp";
            else if ("STD_Faq_QA_List" == this.dotComMenuNm)
                goURL = dotComUrl + "/admin/QA/STD_Faq_QA_List.jsp";
            else if ("STD_Htg_List" == this.dotComMenuNm)
                goURL = dotComUrl + "/admin/HowToGuide/STD_Htg_List.jsp";
            else if ("STD_Htg_QA_List" == this.dotComMenuNm)
                goURL = dotComUrl + "/admin/QA/STD_Htg_QA_List.jsp";
            else if ("STD_Htv_List" == this.dotComMenuNm)
                goURL = dotComUrl + "/admin/HowToGuide/STD_Htv_List.jsp";
            else if ("STD_Htv_QA_List" == this.dotComMenuNm)
                goURL = dotComUrl + "/admin/QA/STD_Htv_QA_List.jsp";
            else if ("STD_Tsg_List" == this.dotComMenuNm)
                goURL = dotComUrl + "/admin/TroubleShootingGuide/STD_Tsg_List.jsp";
            else if ("STD_Tsg_QA_List" == this.dotComMenuNm)
                goURL = dotComUrl + "/admin/QA/STD_Tsg_QA_List.jsp";
            else if ("Simulator_List" == this.dotComMenuNm)
                goURL = dotComUrl + "/simulator/Simulator_List.jsp";
            else if ("mapRatio_List" == this.dotComMenuNm)
                goURL = dotComUrl + "/report/MapRatio_List.jsp";
            else if ("DecisionTree_S" == this.dotComMenuNm)
                goURL = dotComUrl + "/report/DecisionTreeReport.jsp";
            else if ("DecisionTree_P" == this.dotComMenuNm)
                goURL = dotComUrl + "/report/DecisionTreeReport.jsp";
            else if ("DecisionTree_C" == this.dotComMenuNm)
                goURL = dotComUrl + "/report/DecisionTreeReport.jsp";
            else if ("DecisionTree_Q" == this.dotComMenuNm)
                goURL = dotComUrl + "/report/DecisionTreeReport.jsp";
            else if ("" == this.dotComMenuNm)
                goURL = "";

            return goURL;
        },
        btnPopupOpen() {
            // TODO Samsung.com 열기 위한 필수 값이 없을 경우 이벤트 처리 필요
            Vue.$log.info('▶ DotcomMain.vue popup url => ', this.goUrl);
            SDLUtil.openLegacyWindowPopup({
                url: this.goUrl,
                title: 'SAMSUNG.COM SUPPORTED',
                w: 1366,
                h: 768
            });
        }
    },
    created() {
        // SKPMain.vue 전달 -> div#wrap class 변경
        this.$emit('changeWrapClass', 'SDC');
    },
    mounted() {
        /*
            /SKP_TOBE/src/main/webapp/basis/main/dotComSupportMenuJump.jsp 파일 참조
            Landing 시 문구 표기 이벤트 후 윈도우 팝업 오픈
            this.goUrl = this.creDotComMenuUrlByDev(); // 개발
            this.goUrl = this.creDotComMenuUrlByEnv(); // 운영
        */
        this.initLoad().then(resp => {
            let submitData = resp, queryString = '';
            if ("ReportbyRegister_P" == this.dotComMenuNm || "ResReportbyRegister_P" == this.dotComMenuNm ){
                Object.assign(submitData, { report : "P", corpNo : this.userCorpCd });

            } else if  ("ReportbyRegister_R" == this.dotComMenuNm || "ResReportbyRegister_R" == this.dotComMenuNm ){
                Object.assign(submitData, { report : "R", corpNo : this.userCorpCd });

            } else if  ("ReportbyRegister_A" == this.dotComMenuNm || "ResReportbyRegister_A" == this.dotComMenuNm ){
                Object.assign(submitData, { report : "A", corpNo : this.userCorpCd });

            } else if ("ReportbyRegisterContent" == this.dotComMenuNm || "ResReportbyRegisterContent" == this.dotComMenuNm ){
                Object.assign(submitData, { corpNo : this.userCorpCd });

            } else if ("RiskContents" == this.dotComMenuNm || "InvalidContents" == this.dotComMenuNm || "CaresApp" == this.dotComMenuNm ){
                Object.assign(submitData, { corpNo : this.userCorpCd });

            } else if ("ReportbySiteN" == this.dotComMenuNm || "ResReportbySiteN" == this.dotComMenuNm) {
                Object.assign(submitData, { corpNo : this.userCorpCd, closedYN : "N" });

            } else if ("ReportbySiteY" == this.dotComMenuNm || "ResReportbySiteY" == this.dotComMenuNm) {
                Object.assign(submitData, { corpNo : this.userCorpCd, closedYN : "Y" });

            } else if ("DecisionTree_P" == this.dotComMenuNm ) {
                Object.assign(submitData, { corpNo : this.userCorpCd, report : "P" });

            } else if ("DecisionTree_S" == this.dotComMenuNm ){
                Object.assign(submitData, { corpNo : this.userCorpCd, report : "S" });

            } else if ("DecisionTree_C" == this.dotComMenuNm ){
                Object.assign(submitData, { corpNo : this.userCorpCd, report : "C" });

            } else if ("DecisionTree_Q" == this.dotComMenuNm ){
                Object.assign(submitData, { corpNo : this.userCorpCd, report : "Q" });
            };

            queryString = Object.entries(submitData).map(e => e.join('=')).join('&');
            this.goUrl = this.creDotComMenuUrl() + "?" + queryString; // + '&cdsite=20b306a7cd68d08aeb13bb7952f4e5f7&cdia=cb2213299998fe96cb5f6b3fe9b35692';

            this.$nextTick(() => {
                this.btnPopupOpen();
            });

        }).catch(err => {

        });
    },
    beforeDestroy() {
        // SKPMain.vue 전달 -> div#wrap class 변경
        this.$emit('changeWrapClass', 'SKP');
    },
};
</script>
<style scoped></style>


// WEBPACK FOOTER //
// src/skpComponents/view/basis/main/DotComMain.vue